import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "@vilocnv/allsetra-core";
import i18n from "i18next";
import { postKeys } from "domain/keys/api/post-keys";
import { CreateKeysRequestDto } from "domain/keys/entities/dtos/create-keys-request.dto";

const postKeysAction = createAsyncThunk(
  "keys/postKeysAction",
  async (createKeysRequest: CreateKeysRequestDto, thunkAPI) => {
    try {
      return await postKeys(createKeysRequest);
    } catch (error: any) {
      console.error(error);
      if (error?.response?.status !== 409) {
        toast.error(i18n.t("toasts.createKeysError"));
      }
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export default postKeysAction;
